const VUETIFY_ICONS = [
  'icon-telegram-plane',
  'icon-hand-point-right',
  'icon-hand-point-up',
  'icon-thumbs-up',
  'icon-arrow-circle-right',
  'icon-shopping-basket',
]

// Convert some of Vuetify icons to Quasar material symbols icons
const useIconV2Adapter = () => {
  const adaptIcon = (icon: string): string => {
    // Handle special cases for Vuetify icons
    if (VUETIFY_ICONS.includes(icon)) {
      switch (icon) {
        case 'icon-telegram-plane':
          return 'send'
        case 'icon-hand-point-right':
          return 'arrow_forward'
        case 'icon-hand-point-up':
          return 'arrow_upward'
        case 'icon-thumbs-up':
          return 'thumb_up'
        case 'icon-arrow-circle-right':
          return 'arrow_circle_right'
        case 'icon-shopping-basket':
          return 'shopping_basket'
        default:
          return icon
      }
    }

    // Return original icon if not in our conversion list
    return icon
  }

  return {
    adaptIcon,
  }
}

export default useIconV2Adapter
